export const TRANSLATIONS_ZH = {
	//Login Page
	welcome:"欢迎。",
	subWelcome: "使用CDI终端管理和分享数据。",
	enterUsernameAndPassword: "输入邮箱和密码登录",
	problemLoggedIn: "登录异常，请重试",
	email:"邮箱",
	password: "密码",
	login: "登录",

	//Text related to Pitstop
	shareData: "分享数据",
	cdiPitstop: "SGTraDex 终端",
	dataElement: "数据元素",
	na: "-不适用-",
	myPitstop: "我的终端",

	//General Text
	logout: "退出",
	all: "全部",
	pending: "等候",
	success: "成功",
	destination: "目标对象",
	onBehalfOf : "代表对象",
	date: "日期",
	status: "状态",
	share: "分享",
	back: "后退",
	previous: "上一步",
	next: "下一步",
	submit: "提交",
	select: "请选择",
	required: "必选",
	optional: "可选",
	sender: "来自对象",
	download: "下载",

	//Input related
	requiredInput: "必须",

	//Sidebar Nav
	sharedData: "已分享数据",
	receivedData: "已获取数据",

	//Shared Data Page
	notProviderError: "根据您的设定, 您无法提供任何数据元素.",
	filterByDataElement: "数据元素:",
	filterParticipants: "对象:",
	filterStatus: "状态:",
	noRecordsFound: "未找到记录",

	//Share Data Page
	chooseDataElement: "选泽数据元素",
	chooseParticipant: "选择对象",
	selectedDataElements: "Selected Data Element",
	selectedParticipant: "選定的參與者",
	uploadedData: "上传数据",
	uploadData: "上传数据",
	downloadTemplates: "下载模板",
	selectedDataElement: "the selected data element",
	downloadTemplateMessage: `这是数据元素<bold>{{selectedDataElement}}</bold>的参考模板。</bold>`, // Here are the templates you can use as reference for "the selected data element"/"Bill of Lading".
	downloadTemplate: "请点击下载 <json>{{json}}</json> 或 <csv>{{csv}}</csv>。", // Please click and download JSON Template or CSV Template.
	jsonTempalte: "JSON 模板",
	csvTemplate: "CSV 模板",
	chooseDataElementToShare: "选泽您数据元素:",
	chooseWhomToShare: "选择分享对象:",

	//Attachment
	uploadYourData: "上传您的数据",
	dropData: "拖动数据文件至此 或 ",
	browse: "浏览",
	uploadSingleFile: "您可以上传一个数据文件。",
	acceptableFileTypes: "接受的数据文件类型: <bold>json</bold> & <bold>csv</bold>",
	fileReady: "数据文件可被提交",
	additionalInformation: "附加信息",
	referenceId: "参照号码",
	includeAttachments: "包含附件",
	filesToBeAttached: "附件类型可为 <bold>.pdf</bold> 或 <bold>.doc</bold> 或 <bold>.doc</bold> 类型",
	noFilesAttach: "没有数据文件需要上传附件",
	dropFile: "拖动附件至此 或 ",
	requiredCounter: "上传了 {{count}}/{{total}} 个必要附件 ", //1 out of 3 required files have been uploaded

	//Alert
	uploadWrongFile: "您上传的附件格式有误",
	unexpectedError: "未知错误",
	cantUpload: "数据无法上传",
	viewErrorMessage: "查看错误详情",
	item: "条目",

	//Shared Data Success Page
	dataFileShared: "数据文件分享已发出",
	dataFileSharedMessage: "点击下方”回到已分享数据“按钮，可以继续分享",
	backToSharedData: "回到已分享数据",

	//Request Data Success Page
	dataFileRequested: "数据请求已发出",
	dataFileRequestedMessage: "正在处理，稍后可获得数据",
	backToReceivedData: "回到已获得数据",

	//Share/Request Data Fail Page
	somethingWrong: "出错了",
	somethingWrongSharingMessage: "请重新发起数据分享",
	somethingWrongRequestingMessage: "请重新发起数据请求",
	tryAgain: "请重试",
	fail: "失败",

	//Received Data Page
	notConsumerError: "根据您的设定，您无法获取任何数据元素。",
	requestData: "请求数据",

	//Received Data Download Page
	fromDate: "起始日",
	toDate: "终止日",
	noResult: "没有结果",
	attachment: "附件",
	downloadJSON: "下载 JSON",
	downloadCSV: "下载 CSV",

	//Request Data Page
	dataInformation: "数据信息",
	cannotRequestData: "您的请求无法发送",
	fillInAllFields: "请填写全部必填项目",
	chooseDataElementToRetrieve: "请选择数据元素:",
	chooseWhomToRetrieved: "请选择数据来源:"
};
